import { render, staticRenderFns } from "./index.vue?vue&type=template&id=423f526e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423f526e')) {
      api.createRecord('423f526e', component.options)
    } else {
      api.reload('423f526e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=423f526e&", function () {
      api.rerender('423f526e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/follow-up/index.vue"
export default component.exports